<template>
  <div class="d-flex align-items-center">
    <div 
      v-if="rail && 'railClassName' in rail && rail.railClassName"
      class="rail-info"
    >
      <div 
        v-if="direction" 
        class="fw-bold"
      >
        {{ displayRailDirection(direction) }}
      </div>
      <div>{{ rail.railClassName }} {{ displayRailTariff(rail.railTarifCode) }}</div>
    </div>
    <div 
      v-else
      class="message w-100 fs-16 color-sachlich-grey text-center mb-2 mt-3"
    >
      {{ message }}
    </div>
  </div>
</template>

<script lang="ts">
import { IFetchRailOption, SelectableRailOptions } from '@/store/details/rail/interfaces';
import { PropType, defineComponent } from 'vue';
import { getRailLabel, getRailTariff } from '../../../store/details/rail/helper';

export default defineComponent({
  props: {
    rail: { type: Object as PropType<IFetchRailOption | SelectableRailOptions | null>, default: null },
    message: { type: String, default: null },
    direction: { type: String, default: null },
  },

  methods: {
    displayRailDirection: (direction: string) => {
      return getRailLabel(direction)
    },
    
    displayRailTariff: (railTariff: string) => {
      return getRailTariff(railTariff)
    },
  },
})
</script>